import { pushSegmentAnalyticsAddContext } from "utils/segment-analytics/push";
import { pushSegmentAnalyticsIdentify } from "utils/segment-analytics/push";
import { pushSegmentAnalyticsTrack } from "utils/segment-analytics/push";

export const userSegmentLoginSuccess = (user = {}) => {
  if (user?.id) {
    const data = {
      first_name: user.first_name,
      last_name: user.last_name,
      email: user.email,
      phone: user.phone,
      address: {
        street: user?.payment_info?.address,
        city: user?.city || user?.payment_info?.city,
        state: user?.state || user?.payment_info?.state,
        postal_code: user?.zip || user?.payment_info?.zip,
        country: "USA"
      }
    };

    pushSegmentAnalyticsAddContext(data);
    pushSegmentAnalyticsIdentify(user.sso__user_id, data);
    pushSegmentAnalyticsTrack('Signed In', {
      form_name: 'Sign In',
      cwh_business: 'RV Rentals'
    });
  }
};
